module.exports = __webpack_public_path__ + "img/chipping6.00e9d7d7.png";